/* eslint-disable init-declarations */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable camelcase */
/* eslint-disable object-curly-spacing */
/* eslint-disable space-before-function-paren */
import React, { Component } from 'react';
import { loadModules, loadCss } from 'esri-loader';
import satTrack from '../../resources/satTrack';
import esriStrings from '../../resources/esriStrings';
import './viewContainer.scss';

export default class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: null,
      map: null,
      featureLayer: null,
      featureLayerUrl: props.featureLayerUrl,
      vectorLayer: null,
      vectorLayerUrl: props.vectorLayerUrl,
      search: null,
      currentCenter: {}
    };
  }
  async makeVectorLayer(params) {
    const [VectorTileLayer] = await loadModules([
      'esri/layers/VectorTileLayer'
    ]);
    const vectorLayer = new VectorTileLayer({ opacity: 1, ...params });

    return vectorLayer;
  }
  async setVectorUrl(url) {
    if (this.state.vectorLayer) {
      const id = this.state.vectorLayer.id;

      this.state.vectorLayer.url = url;
      await this.state.map.remove(this.state.vectorLayer);
      const newVL = await this.makeVectorLayer({ id, url });
      this.state.map.add(newVL, 0);
      this.setState({ vectorLayer: await newVL });
    }
  }
  async setDriveTimePoly(polyGeometry, pointGeometry) {
    const [Graphic] = await loadModules(['esri/Graphic']);
    const spatialRef = this.state.view.spatialReference;
    const fillSymbol = {
      type: 'simple-fill',
      color: [137, 189, 250, 0.3],
      outline: {
        color: '#0079c1',
        width: 1
      }
    };
    const polygon = {
      type: 'polygon',
      rings: polyGeometry.rings,
      spatialReference: spatialRef
    };
    const pointSymbol = {
      type: 'picture-marker',
      url:
        'https://webapps-cdn-dev.esri.com/Apps/know-your-neighborhood/img/Gartner_Pin_1.png',
      width: '26px',
      height: '48px',
      yoffset: '24px'
    };
    const point = {
      type: 'point',
      spatialReference: spatialRef,
      longitude: pointGeometry.x,
      latitude: pointGeometry.y
    };

    this.state.drivetimeLayer.removeAll();
    const dtGraphic = new Graphic({
      geometry: polygon,
      symbol: fillSymbol
    });
    const dtPointGraphic = new Graphic({
      geometry: point,
      symbol: pointSymbol
    });
    this.state.drivetimeLayer.add(dtGraphic);
    this.state.drivetimeLayer.add(dtPointGraphic);
    if (this.state.drivetimeLayer.visible) {
      this.zoomTo(dtGraphic, this.state.view);
    }
  }
  setDriveTimeVisiblity(isVisible) {
    if (this.state.drivetimeLayer) {
      this.state.drivetimeLayer.visible = isVisible;
    }
  }
  async handleSearchResult(mapPoint, eventType, onValid, onInvalid) {

    // this.props.addInterationCount()
    const query = this.state.featureLayer.createQuery();
    query.geometry = mapPoint;
    query.spatialRelationship = 'intersects';
    query.outFields = '*';
    // query.where = 'populationtotals_totpop_cy > 0';
    const results = await this.state.featureLayer.queryFeatures(query);
    try {
      const target = results.features[0];
      const zipcode = target.attributes.ID;
      this.props.onFeature(target);
      this.addZipLabel({ zipcode, layer: this.state.labelLayer });
      this.addOutline(target, this.state.outlineLayer, zipcode);
      this.zoomTo(target, this.state.view);
      if (eventType === 'mapclick') {
        satTrack('map_click', { sucess: true, Description: 'User Click on map', zip_code_match: target.attributes.ID, click_lat: mapPoint.latitude, click_long: mapPoint.longitude });
      }
      if (onValid) {
        onValid(target);
      }
    } catch (err) {
      // console.log(err);
      satTrack('map_click', { sucess: false, Description: 'User Click on map', click_lat: mapPoint.latitude, click_long: mapPoint.longitude });
      if (onInvalid) {
        onInvalid(err);
      }
    }
  }
  async initMap() {
    loadCss();
    const [
      MapView,
      Map,
      FeatureLayer,
      Search,
      GraphicsLayer,
      Basemap,
      VectorTileLayer,
      Expand
    ] = await loadModules(
      [
        'esri/views/MapView',
        'esri/Map',
        'esri/layers/FeatureLayer',
        'esri/widgets/Search',
        'esri/layers/GraphicsLayer',
        'esri/Basemap',
        'esri/layers/VectorTileLayer',
        'esri/widgets/Expand'
      ],
      { css: 'https://js.arcgis.com/4.14/esri/themes/dark/main.css' }
    );
    const basemap = new Basemap({
      baseLayers: [
        new VectorTileLayer({
          portalItem: {
            id: 'd7397603e9274052808839b70812be50' // Forest and Parks Canvas
          }
        })
      ]
    });

    const map = new Map({ basemap });
    const view = new MapView({
      map,
      center: [-94.552733, 39.1035],
      zoom: 12,
      container: 'viewTarget',
      constraints: {
        minZoom: 4
      }
    });
    const sources = [
      {
        layer: new FeatureLayer({
          url: 'https://services1.arcgis.com/G84Qg78md8fRCEAD/arcgis/rest/services/AppDataScrubbed/FeatureServer/0',
          // url: 'https://services1.arcgis.com/G84Qg78md8fRCEAD/arcgis/rest/services/ZipCodes_base/FeatureServer/0',
          outFields: ['*']
        }),
        searchFields: ['ID', 'NAME', 'RG_NAME'],
        displayField: 'ID',
        searchTemplate: '{NAME}, {RG_NAME}, {ID}',
        exactMatch: false,
        outFields: ['*'],
        name: 'Point FS',
        placeholder: esriStrings.searchPlaceHolder,
        maxResults: 6,
        maxSuggestions: 6,
        suggestionsEnabled: true,
        minSuggestCharacters: 0
      }
    ];
    const search = new Search({
      view,
      popupEnabled: false,
      resultGraphicEnabled: false,
      sources,
      includeDefaultSources: false
    });
    search.on('search-complete', (evt) => {

      if (evt.numResults < 1) {
        satTrack('location_search', { interface: 'map', success: false, zip_search_term: evt.searchTerm, Description: 'Map ZIP Code lookup attempt' });
      } else {
        const zip = evt.results[0].results[0].feature.attributes.ID;
        satTrack('location_search', { interface: 'map', success: true, zip_search_code: zip, zip_search_term: evt.searchTerm, Description: 'Map ZIP Code lookup attempt' });
      }
    });

    const legendImage = document.createElement('img');
    legendImage.src = '';

    view.ui.add(search, {
      position: 'top-left',
      index: 2
    });
    view.ui.move(['zoom'], 'top-right');

    const featureLayer = new FeatureLayer({
      url:
        'https://services1.arcgis.com/G84Qg78md8fRCEAD/arcgis/rest/services/AppDataScrubbed/FeatureServer/0',
      // 'https://services1.arcgis.com/G84Qg78md8fRCEAD/arcgis/rest/services/ZipCodes_base/FeatureServer/0',
      opacity: 0.0000001,
      outFields: ['*']
    });
    search.goToOverride = async (view, goToParams) => {

      const $mapPoint = goToParams.target.target.geometry.extent.center;

      const query = featureLayer.createQuery();
      query.geometry = $mapPoint;
      query.spatialRelationship = 'intersects';
      query.outFields = '*';
      const results = await featureLayer.queryFeatures(query);
      try {
        const target = results.features[0];
        const zipcode = target.attributes.ID;
        this.props.onFeature(target);

        this.addZipLabel({ zipcode, layer: this.state.labelLayer });
        this.addOutline(target, this.state.outlineLayer, zipcode);
        this.zoomTo(target, view);
      } catch (err) {
        // console.log(err);
      }
    };
    const drivetimeLayer = await new GraphicsLayer({
      opacity: 1,
      visible: false
    });
    const outlineLayer = await new GraphicsLayer({});
    const vectorLayer = await this.makeVectorLayer({
      id: 'vectorlayer',
      url:
        'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/tapestry_groups/VectorTileServer'
    });
    const humanGeoDetailsLayer = await this.makeVectorLayer({
      id: 'humanGeoDetailsLayer',
      style:
        // 'https://webops.maps.arcgis.com/sharing/rest/content/items/1ddbb25aa29c4811aaadd94de469856a/resources/styles/root.json?f=pjson',
        'https://webops.maps.arcgis.com/sharing/rest/content/items/97fa1365da1e43eabb90d0364326bc2d/resources/styles/root.json?f=pjson',
      opacity: 0.5
    });
    const humanGeoLabelsLayer = await this.makeVectorLayer({
      id: 'humanGeoDetailsLayer',
      style:
        'https://webops.maps.arcgis.com/sharing/rest/content/items/4a3922d6d15f405d8c2b7a448a7fbad2/resources/styles/root.json?f=pjson',
      opacity: 1
    });
    const labelLayer = await new FeatureLayer({
      url: 'https://services1.arcgis.com/G84Qg78md8fRCEAD/arcgis/rest/services/zip_pop_stripped/FeatureServer/0',
      definitionExpression: 'ID = 00000'
    });
    map.addMany([vectorLayer, drivetimeLayer, humanGeoDetailsLayer, outlineLayer, humanGeoLabelsLayer, labelLayer]);
    this.setState({
      view,
      map,
      featureLayer,
      vectorLayer,
      search,
      drivetimeLayer,
      outlineLayer,
      labelLayer
    });
    view.when(() => {
      this.props.setEsriView(view);
    });
    view.on('click', async (evt) => {

      // const response = await view.hitTest(evt);
      const $mapPoint = evt.mapPoint;
      this.handleSearchResult($mapPoint, 'mapclick');
    });
    let centertimeout;
    let zoomtimeout;
    view.watch('zoom', (evt) => {
      if (zoomtimeout) {
        clearTimeout(zoomtimeout);
      }
      zoomtimeout = setTimeout(() => {
        satTrack('map_zoom_update', { map_zoom_level: view.zoom, Description: 'New Map Zoom Level' });
      }, 700);
    });
    view.watch('center', (evt) => {
      if (centertimeout) {
        clearTimeout(centertimeout);
      }
      centertimeout = setTimeout(() => {
        if (this.state.currentCenter.latitude !== view.center.latitude || this.state.currentCenter.longitude !== view.center.longitude) {
          this.setState({ currentCenter: { latitude: view.center.latitude, longitude: view.center.longitude } }, () => {
            satTrack('map_center_update', { map_center_lat: view.center.latitude, map_center_long: view.center.longitude, Description: 'New Map Center' });
          });
        }

      }, 500);
    });
  }

  zoomTo(feature, view) {
    const clone = feature.clone();
    clone.geometry.extent.expand(2);
    view.goTo(clone);
  }
  addZipLabel({ zipcode, layer }) {
    if (typeof zipcode !== 'undefined' && typeof layer !== 'undefined') {
      layer.definitionExpression = `ID = ${zipcode}`;
    }
  }
  addOutline(feature, graphicLayer, valString) {
    if (feature.clone) {
      this.props.setCurrentZIP(valString);
      this.state.search.searchTerm = valString;
      const graphic = feature.clone();
      graphic.symbol = {
        type: 'simple-fill',
        color: [0, 0, 0, 0],
        outline: {
          color: '#fff',
          width: '3px'
        }
      };
      const gl = graphicLayer || this.state.outlineLayer;
      gl.removeAll();
      gl.add(graphic);
    }
  }
  componentDidMount() {
    this.initMap();
  }
  render() {
    return (
      <div className="view-container">
        <div id="viewTarget"></div>
      </div>
    );
  }
}
